import { useEffect, useState } from "react";
import axios from "axios";
import { Download, Loader2, ZoomIn, ZoomOut } from "lucide-react";
import { API } from "../App";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const LeadSheetViewer = ({ contentId, onClose }) => {
  const [sheet, setSheet] = useState(null);
  const [error, setError] = useState(null);
  const [zoom, setZoom] = useState(false);

  useEffect(() => {
    if (!contentId) return;
    setSheet(null);
    setError(null);
    setZoom(false);
    axios
      .get(`${API}/lead-sheets/${contentId}`)
      .then((r) => setSheet(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Could not open this Lead Sheet"));
  }, [contentId]);

  return (
    <Dialog open={!!contentId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[92vh] max-w-5xl flex-col gap-3 p-3 sm:p-5" data-testid="lead-sheet-viewer">
        <div className="flex flex-wrap items-center justify-between gap-3 pr-8">
          <div>
            <DialogTitle className="font-serif text-lg">Legal Lead Sheetz™</DialogTitle>
            <DialogDescription className="text-xs">{sheet ? `${sheet.course_name} · ${sheet.title}` : " "}</DialogDescription>
          </div>
          {sheet && (
            <div className="flex gap-2">
              <Button variant="outline" size="sm" className="rounded-full" onClick={() => setZoom((z) => !z)} data-testid="lead-sheet-viewer-zoom">
                {zoom ? <ZoomOut className="mr-1.5 h-4 w-4" /> : <ZoomIn className="mr-1.5 h-4 w-4" />}
                {zoom ? "Fit" : "Zoom"}
              </Button>
              <Button size="sm" className="rounded-full" onClick={() => { window.location.href = `${BACKEND}${sheet.pdf_url}`; }} data-testid="lead-sheet-viewer-download">
                <Download className="mr-1.5 h-4 w-4" /> PDF
              </Button>
            </div>
          )}
        </div>
        <div className="flex-1 overflow-auto rounded-xl bg-secondary/40" data-testid="lead-sheet-viewer-scroll">
          {error && <p className="p-8 text-center text-sm text-muted-foreground" data-testid="lead-sheet-viewer-error">{error}</p>}
          {!sheet && !error && <div className="flex h-full items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>}
          {sheet && (
            <img
              src={`${BACKEND}${sheet.image_url}`}
              alt={`Legal Lead Sheetz study chart for ${sheet.title}`}
              className={zoom ? "h-auto w-[220%] max-w-none sm:w-[160%]" : "mx-auto h-full w-auto max-w-full object-contain"}
              data-testid="lead-sheet-viewer-image"
            />
          )}
        </div>
        <p className="text-[11px] text-muted-foreground">Licensed to you for personal study. Downloads are stamped with your account email.</p>
      </DialogContent>
    </Dialog>
  );
};
